import { NavigationClient } from "@azure/msal-browser";
 
/**
 * This is an example for overriding the default function MSAL uses to navigate to other urls in your webpage
 */
export class CustomNavigationClient extends NavigationClient{
    
    constructor(history) {
        super();
        this.history = history;
        console.log("CustomNavigationClient");
    }
    
    /**
     * Navigates to other pages within the same web application
     * You can use the useHistory hook provided by react-router-dom to take advantage of client-side routing
     * @param url 
     * @param options 
     */
    async navigateInternal(url, options) {
        console.log("------------------------>")
        console("URL and Options"+url+","+options);
        const relativePath = url.replace(window.location.origin, '');
        console.log("relativePath"+relativePath)
        if (options.noHistory) {
            this.history.replace(relativePath);
        } else {
            this.history.push(relativePath);
        }
 
        return false;
    }
}